<app-modal
  [title]="title || ('Input ticket number' | trans:'tickets/ticket-number-modal/header/title')"
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      <app-form-control
        label="{{ 'Ticket number'| trans:'tickets/ticket-number-modal/ticketNr.Label' }}"
      >
        <input
          #ticketNrInput
          type="number"
          [(ngModel)]="ticketNr"
          placeholder="{{ 'Enter ticket number'| trans:'tickets/ticket-number-modal/ticketNr.Placeholder' }}"
        >
      </app-form-control>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'tickets/ticket-number-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="!ticketNr"
        (click)="confirm.emit(ticketNr)"
      >
        {{ 'Confirm'| trans:'tickets/ticket-number-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
